import { withAnalyticsTracking } from '@/utilities/analytics/apiAnalytics'
import { errorAnalyticsPayload } from '@/utilities/analytics/errorAnalytics'
import { trackEvent } from '@/utilities/analytics/trackEvent'
import { syncPartnerIdsAction } from '@/repositories/payloadServerRepository'

export type PartnerSyncContext = 'existing-user-authentication' | 'new-user-registration'

type SyncPartnerIds = {
  context: PartnerSyncContext
  analyticsProperties?: {
    kitId?: string
  }
}

export async function syncTenantPartnerIds({ context, analyticsProperties }: SyncPartnerIds) {
  const additionalProperties = {
    context,
    ...analyticsProperties,
  }

  try {
    const result = await withAnalyticsTracking(() => syncPartnerIdsAction(), {
      eventName: 'tenant:sync_partner_ids_api',
      additionalProperties,
    })

    if (result.skipped) {
      if (result.skippedReason === 'impersonated') {
        trackEvent('tenant:sync_partner_ids_skip_impersonated', {
          ...additionalProperties,
          gate: 'partner_id_sync',
          source: 'syncPartnerIdsAction',
        })
        return
      }

      trackEvent('tenant:sync_partner_ids_skip_already_exists', additionalProperties)
      return
    }

    trackEvent('tenant:sync_partner_ids_success', additionalProperties)
  } catch (error) {
    trackEvent('tenant:sync_partner_id_fail', {
      ...additionalProperties,
      ...errorAnalyticsPayload(error),
    })
  }
}
